import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { faMoneyBill, faTools, faCheck, faChartBar, faMapPin } from '@fortawesome/free-solid-svg-icons';
import { taxTypes } from '../../../../constants/companies';
import Rating from '../../ui/Rating';
import FilterRow from '../FilterRow';
import { activeStatuses } from '../../../../constants/workers';
import { mapSkillsListToUI } from '../../../../helpers/general';

export default class FilterWorkers extends Component {
  handleRating = value => {
    const newRating = value === this.props.rating ? null : value;

    this.props.handleChange('rating', newRating);
  };

  handleChange = event => this.props.handleChange(event.target.name, event.target.value);

  render () {
    const { tax_type, handleChange, skillsList, skill, is_active, rating, distance, zip } = this.props;

    return (
      <Fragment>
        <FilterRow title='Tax Type' icon={faMoneyBill}>
          <div className='d-flex'>
            {Object.keys(taxTypes).map(taxType => (
              <button
                type={'button'}
                key={taxType}
                children={taxTypes[taxType]}
                className={`button button-primary button-small ${tax_type === taxTypes[taxType] ? 'active' : ''}`}
                onClick={() => handleChange('tax_type', taxTypes[taxType])}
              />
            ))}
          </div>
        </FilterRow>

        <FilterRow title='Active Status' icon={faCheck}>
          <div className='btn-group-sm btn-group'>
            {activeStatuses.map(status => (
              <button
                type={'button'}
                key={status.value}
                children={status.label}
                className={`button button-primary button-small ${is_active === status.value ? 'active' : ''}`}
                onClick={() => handleChange('is_active', status.value)}
              />
            ))}
          </div>
        </FilterRow>

        <FilterRow title='Skills' icon={faTools}>
          <Select
            multi
            value={skill}
            onChange={value => handleChange('skill', value)}
            options={mapSkillsListToUI(skillsList)}
            placeholder={'Choose Skills'}
          />
        </FilterRow>

        <FilterRow title='Region' icon={faMapPin}>
          <div className='d-flex align-items-center'>
            Within
            <label className='d-flex align-items-center'>
              <input type='number' min={0} step={1} className='input input-short mx-2 text-center' placeholder='miles' value={distance} name='distance' onChange={this.handleChange} />
              miles
            </label>
            <label className='d-flex align-items-center ml-2'>
              of
              <input type='number' className='input input-short ml-2 text-center' placeholder='zip' value={zip} name='zip' onChange={this.handleChange} />
            </label>
          </div>
        </FilterRow>

        <FilterRow title='Rating' icon={faChartBar}>
          <Rating value={rating} setRating={this.handleRating} />
        </FilterRow>
      </Fragment>
    );
  }
}

FilterWorkers.propTypes = {
  tax_type: PropTypes.string,
  handleChange: PropTypes.func,
  skillsList: PropTypes.array,
  skill: PropTypes.array,
  is_active: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  rating: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  distance: PropTypes.string,
  zip: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/common/AdvancedFilter/FilterWorkers/index.js